import React from 'react';
import { BooleanPropertyValue } from './boolean-property-value';
import { StringPropertyValue } from './string-property-value';
import { NumberPropertyValue } from './number-property-value';
import { IntervalPropertyValue } from './interval-property-value';
import { ListPropertyValue } from './list-property-value';
import { Property } from './types';

function unsupportedPropertyType(_property: never) {
  return null;
}

type Props = {
  property: Property;
  booleanTrueText: string;
  booleanFalseText: string;
};

export function PropertyValue({
  property,
  booleanTrueText,
  booleanFalseText,
}: Props) {
  switch (property.type) {
    case 'boolean':
      return (
        <BooleanPropertyValue
          property={property}
          booleanTrueText={booleanTrueText}
          booleanFalseText={booleanFalseText}
        />
      );
    case 'string':
      return <StringPropertyValue property={property} />;
    case 'integer':
    case 'decimal':
      return <NumberPropertyValue property={property} />;
    case 'interval':
      return <IntervalPropertyValue property={property} />;
    case 'list':
      return <ListPropertyValue property={property} />;
    default:
      return unsupportedPropertyType(property);
  }
}
